export var ACTION;
(function (ACTION) {
    ACTION["COPY_LINK"] = "COPY_LINK";
    ACTION["INVITE_WHATSAPP"] = "INVITE_WHATSAPP";
    ACTION["CLOSE_INVITE_MODAL"] = "CLOSE_INVITE_MODAL";
})(ACTION || (ACTION = {}));
